import { useState, useEffect } from 'react';
import cx from 'classnames';
import s from './CoinStats.module.scss';
import _get from 'lodash/get';
import CoinIcon from '@/shared/ui/CoinIcon';
import TextLoader from '@/shared/ui/TextLoader';

type CoinStatsProps = {
  coin: string;
  value: string;
  subValue?: string;
  label?: string | JSX.Element;
  tip?: string;
  className?: string;
  isLoading?: boolean;
}

const CoinStats = (props: CoinStatsProps) => {
  const {
    coin = 'BTC',
    className = '',
    label = '',
    value = '',
    subValue = '',
    tip = '',
    isLoading = false,
  } = props;

  return (
    <div className={cx("flex items-start", className)}>
      <CoinIcon coin={coin} className="w-[50px] h-[50px] mr-4"/>
      <div>
        {label ? (<div className="text-base mb-1.5">{label}</div>) : null}
        <div className="mb-1.5">
          {isLoading ? <TextLoader width='100px'/> : (
            <>
              <span className='text-xl sm:text-3xl font-medium'>{value}</span>
              {subValue ? (
                <>
                  <span className='text-white/[0.6] mx-1'> / </span>
                  <span className='text-white/[0.6] font-medium'>{subValue}</span>
                </>
              ) : null}
            </>
          )}
        </div>
        {tip ? (
          isLoading 
            ? <TextLoader width="50px"/> 
            : <div className="text-white/[0.6] text-sm">{tip}</div>
        ) : null}
      </div>
    </div>
  );
}

export default CoinStats;
